const createFundraiserApi = async (formData) => {
	const token = localStorage.getItem('api-token');
	const editedFormData = {
		name: formData.name,
		description: formData.description,
        organization_id: formData.organizationId,
		start_at: formData.startAt,
		end_at: formData.endAt,
		goal_amount: formData.goalAmount,
		pictures_urls: formData.images
	};
	if(formData.requestDirectPayment){
		editedFormData.request_direct_payment = true;
	}
	const options = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		},
		body: JSON.stringify(editedFormData)
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser', options);
};

const updateFundraiserApi = async (fundraiserId, property, value) => {
	const token = localStorage.getItem('api-token');
	const editedFormData = {
		property_name: property,
		property_value: value
	};
	const options = {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		},
		body: JSON.stringify(editedFormData)
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId , options);
};

const endFundraiserApi = async (fundraiserId) => {
	const token = localStorage.getItem('api-token');
	const options = {
		method: 'PUT',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		}
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId + '/end', options);
};

const createFundraiserUpdateApi = async (fundraiserId, formData) => {
    const token = localStorage.getItem('api-token');
    const editedFormData = {
        title: formData.title,
        text: formData.text,
        pictures_urls: formData.images
    };
    const options = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            token: token
        },
        body: JSON.stringify(editedFormData)
    };
    return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId + '/update', options);
};

const updateFundraiserRequestApi =async (fundraiserId, status) => {
	const token = localStorage.getItem('api-token');
	const formData = {
		status: status
	};
    const options = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            token: token
        },
        body: JSON.stringify(formData)
    };
    return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId + '/request', options);
};

const getAllFundraisresApi = async () => {
    const options = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    };
    return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraisers/all', options);
};

const getCurrentUserFundraisersApi = async () => {
	const token = localStorage.getItem('api-token');
	const options = {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		}
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraisers', options);
};

const getFundraiserApi = async (fundraiserId) => {
	const token = localStorage.getItem('api-token');
	const options = {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		}
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId, options);
};

const submitDonationApi = async (fundraiserId, formData, financialConnectionsAccountId, stripeConfirmationToken, lastFourDigitsOfCard) => {
	const editedFormData = {
		amount: formData.amount,
		tip: formData.tipAmount ? formData.tipAmount : 0,
		email: formData.email,
		name: formData.displayName,
		comment: formData.comment,
		financial_connections_account_id: financialConnectionsAccountId,
		stripe_confirmation_token: stripeConfirmationToken,
		last_four_digits_of_card: lastFourDigitsOfCard
	};
	const options = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(editedFormData)
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId + '/donate', options);
};

const submitOfflineDonationApi = async (fundraiserId, amount, displayName) => {
	const token = localStorage.getItem('api-token');
	const editedFormData = {
		amount: amount,
		name: displayName
	};
	const options = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		},
		body: JSON.stringify(editedFormData)
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId + '/donate/offline', options);
};

const requestDonationsReportApi = async (fundraiserId) => {
	const token = localStorage.getItem('api-token');
	const options = {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			token: token
		}
	};
	return await fetch(process.env.REACT_APP_BACK_END_DOMAIN + '/fundraiser/' + fundraiserId + '/donations/report', options);
};

export { createFundraiserApi, updateFundraiserApi, endFundraiserApi, createFundraiserUpdateApi, updateFundraiserRequestApi, getAllFundraisresApi, getCurrentUserFundraisersApi,
		 getFundraiserApi, submitDonationApi, submitOfflineDonationApi, requestDonationsReportApi };